import { Button, Group, Modal, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import { TbUnlink } from "react-icons/tb";
import { useNavigate } from "@tanstack/react-router";
import { useUnlinkPatreonAccount } from "@/api/fapinstructor/patreon/unlink-patreon-account";

export function UnlinkPateronButton() {
  const [opened, { open, close }] = useDisclosure(false);
  const unlinkPatreonAccountMutation = useUnlinkPatreonAccount();
  const navigate = useNavigate();

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        title="Unlink Patreon Account?"
        centered
      >
        <Stack>
          <Text>
            Are you sure you want to unlink your account?{" "}
            <Text c="red">
              You will immediately lose access to the site until you relink to
              Patreon.
            </Text>
          </Text>
          <Group justify="center">
            <Button
              color="red"
              onClick={async () => {
                try {
                  await unlinkPatreonAccountMutation.mutateAsync();
                  notifications.show({
                    title: "Unlink was successful",
                    message: "Your Patreon account was successfully unlinked",
                    color: "green",
                  });
                  navigate({ to: "/patreon/signup" });
                } catch {
                  notifications.show({
                    title: "Something went wrong",
                    message:
                      "An error occured while trying to unlink your Patreon account.",
                    color: "red",
                  });
                }
              }}
            >
              Unlink Account
            </Button>
            <Button variant="outline" onClick={close}>
              Cancel
            </Button>
          </Group>
        </Stack>
      </Modal>
      <Button
        leftSection={<TbUnlink />}
        color="red"
        variant="outline"
        onClick={open}
      >
        Unlink Patreon account
      </Button>
    </>
  );
}
